// 20 curated images distributed across 3 categories
export const GALLERY_CATEGORIES = [
  { id: "toate", label: "Toate" },
  { id: "preparate", label: "Preparate" },
  { id: "interior", label: "Interior" },
  { id: "evenimente", label: "Evenimente" },
];

export const GALLERY = [
  // Preparate (food) — 8
  {
    id: 1,
    category: "preparate",
    title: "Foie Gras Maison",
    src: "https://images.unsplash.com/photo-1551183053-bf91a1d81141?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },
  {
    id: 2,
    category: "preparate",
    title: "Magret de Canard",
    src: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?auto=format&fit=crop&w=900&q=80",
    aspect: "wide",
  },
  {
    id: 3,
    category: "preparate",
    title: "Tartare de Somon",
    src: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&w=900&q=80",
    aspect: "square",
  },
  {
    id: 4,
    category: "preparate",
    title: "Crème Brûlée",
    src: "https://images.unsplash.com/photo-1470124182917-cc6e71b22ecc?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },
  {
    id: 5,
    category: "preparate",
    title: "Bisque de Homard",
    src: "https://images.pexels.com/photos/28616663/pexels-photo-28616663.jpeg?auto=compress&cs=tinysrgb&w=900",
    aspect: "wide",
  },
  {
    id: 6,
    category: "preparate",
    title: "Filet Rossini",
    src: "https://images.unsplash.com/photo-1432139509613-5c4255815697?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },
  {
    id: 7,
    category: "preparate",
    title: "Tarte Tatin",
    src: "https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=900&q=80",
    aspect: "square",
  },
  {
    id: 8,
    category: "preparate",
    title: "Carpaccio de Vită",
    src: "https://images.pexels.com/photos/24246114/pexels-photo-24246114.jpeg?auto=compress&cs=tinysrgb&w=900",
    aspect: "wide",
  },

  // Interior — 7
  {
    id: 9,
    category: "interior",
    title: "Sala Principală",
    src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80",
    aspect: "wide",
  },
  {
    id: 10,
    category: "interior",
    title: "Atmosfera Candle-lit",
    src: "https://images.pexels.com/photos/36747296/pexels-photo-36747296.jpeg?auto=compress&cs=tinysrgb&w=900",
    aspect: "tall",
  },
  {
    id: 11,
    category: "interior",
    title: "Barul de Vinuri",
    src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=900&q=80",
    aspect: "square",
  },
  {
    id: 12,
    category: "interior",
    title: "Salonul Privat",
    src: "https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },
  {
    id: 13,
    category: "interior",
    title: "Pivnița Maison",
    src: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=900&q=80",
    aspect: "wide",
  },
  {
    id: 14,
    category: "interior",
    title: "Detaliu Tavan",
    src: "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&w=900&q=80",
    aspect: "square",
  },
  {
    id: 15,
    category: "interior",
    title: "Aranjament Floral",
    src: "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },

  // Evenimente — 5
  {
    id: 16,
    category: "evenimente",
    title: "Seară Privată",
    src: "https://images.pexels.com/photos/16935897/pexels-photo-16935897.jpeg?auto=compress&cs=tinysrgb&w=900",
    aspect: "wide",
  },
  {
    id: 17,
    category: "evenimente",
    title: "Toast cu Şampanie",
    src: "https://images.pexels.com/photos/3660703/pexels-photo-3660703.jpeg?auto=compress&cs=tinysrgb&w=900",
    aspect: "tall",
  },
  {
    id: 18,
    category: "evenimente",
    title: "Aniversare",
    src: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=900&q=80",
    aspect: "square",
  },
  {
    id: 19,
    category: "evenimente",
    title: "Cină Romantică",
    src: "https://images.unsplash.com/photo-1529543544282-ea669407fca3?auto=format&fit=crop&w=900&q=80",
    aspect: "tall",
  },
  {
    id: 20,
    category: "evenimente",
    title: "Eveniment Corporate",
    src: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=900&q=80",
    aspect: "wide",
  },
];
